import { render, staticRenderFns } from "./submitButton.vue?vue&type=template&id=3d989ebe"
import script from "./submitButton.vue?vue&type=script&lang=ts"
export * from "./submitButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports